module.exports = __webpack_public_path__ + "img/gdtou.aea0c4fb.png";